export function isAbsoluteUrl(url: string): boolean {
  const regex = /^[^/]*\.[^/]+/gm;
  const test = regex.test(url);

  if (url.startsWith('http')) {
    return true;
  }

  if (test) {
    return true;
  }

  return false;
}

export function startsWithProtocol(url: string): boolean {
  // regex determines if a string starts with http:// or https://
  const protocolCheckRegex = /^https?:\/\//;

  return protocolCheckRegex.test(url);
}

export function getFriendlyURL(
  url: string | undefined,
  includeWWW: boolean | undefined = false,
) {
  if (!url) return null;

  const urlified = new URL(url);
  const { hostname } = urlified;
  const noWWWHostname = hostname.replace('www.', '');

  if (includeWWW) {
    return hostname;
  }

  return noWWWHostname;
}
